<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface EmbeddedVideoProps {
  src: string
  title: string
  aspectRatio?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { ref } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { Spinner } from '#ui-kit/ui/spinner'

const props = withDefaults(defineProps<EmbeddedVideoProps>(), {
  aspectRatio: '9/16',
})

const loaded = ref(false)
</script>

<template>
  <div
    data-slot="embedded-video"
    :class="cn('relative overflow-hidden rounded-2xl', props.class)"
    :style="{ aspectRatio: props.aspectRatio }"
  >
    <iframe
      v-show="loaded"
      :src="props.src"
      :title="props.title"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
      class="size-full"
      @load="loaded = true"
    />
    <div v-if="!loaded" class="flex size-full items-center justify-center">
      <Spinner size="md" />
    </div>
  </div>
</template>
